/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
export { ClipboardModule, ClipboardDirective, ClipboardService } from "./src/index";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-clipboard/dist/index.js
// module id = 964
// module chunks = 3